export default __webpack_public_path__ + "static/media/redPlane.1e49892c.png";